import { render, staticRenderFns } from "./daochu.vue?vue&type=template&id=f4557cfe&"
import script from "./daochu.vue?vue&type=script&lang=js&"
export * from "./daochu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports